import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-close\">\r\n  <path d=\"M1.707.293A1,1,0,0,0,.293,1.707L5.586,7,.293,12.293a1,1,0,0,0,1.414,1.414L7,8.414l5.293,5.293a1,1,0,0,0,1.414-1.414L8.414,7l5.293-5.293A1,1,0,0,0,12.293.293L7,5.586Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol